import isServerSideRendering from '~/utilities/isServerSideRendering';
import { logError } from '~/utilities/loggers';
import safeParse from '~/utilities/safeParse';

export function loadItemFromLocalStorage<T>(name: string): T | undefined {
  if (isServerSideRendering) return undefined;

  const serializedState = window.localStorage.getItem(name);

  return serializedState ? safeParse<T>(serializedState) : undefined;
}

export function saveItemToLocalStorage(name: string, state: any): boolean {
  try {
    window.localStorage.setItem(name, JSON.stringify(state));

    return true;
  } catch (err) {
    logError(err, { location: 'Save item to localStorage' });

    return false;
  }
}

export function removeItemFromLocalStorage(name: string): boolean {
  try {
    window.localStorage.removeItem(name);

    return true;
  } catch (err) {
    logError(err, { location: 'Remove item from localStorage' });

    return false;
  }
}
